import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const roleColumns: GridColumnConfig[] = [
  {
    title: 'Role Name',
    field: 'roleName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Role Code',
    field: 'roleCode',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Description',
    field: 'roleDescription',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Option',
    field: 'option',
    filter: 'text',
    width: '150px',
  },
];
